import styled, { keyframes } from 'styled-components';

import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const Block = styled.div<{ $h: number; $r: number; $w: string }>`
  width: ${({ $w }) => $w};
  height: ${({ $h }) => $h}px;
  border-radius: ${({ $r }) => $r}px;
  background: linear-gradient(90deg, ${CUST.skeletonBg} 25%, ${CUST.skeletonShine} 37%, ${CUST.skeletonBg} 63%);
  background-size: 400% 100%;
  animation: ${shimmer} ${CUST_ANIM.SKELETON_SHIMMER_MS}ms ease infinite;
`;